import React from 'react';
import { IoIosAddCircleOutline } from "react-icons/io";
import { PiExportBold } from "react-icons/pi";
import { LuImport } from "react-icons/lu";
import { FiFilter } from "react-icons/fi";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import './Button.css';

const ModelButtonField = ( props ) => {
    return(
        <div>
            <button color={props.color} style={{
                borderRadius: '17px',
                fontSize: '0.9rem',
                width:'13%',
                float:'right',
                marginRight: '5%',
            }}
                rounded
                type='button'
                className='btn-block z-depth-1 col-md-4'
                onClick={props.submit}
            >
            {props.BName}
            </button>
        </div>
    );
}

const ButtonField = (props) => {

    const root = document.documentElement;
    const buttonBackgroundColor = getComputedStyle(root).getPropertyValue('--button_background-color').trim();
    const closeButtonBackgroundColor = getComputedStyle(root).getPropertyValue('--close-button_background-color').trim();
    const buttonTextColor = getComputedStyle(root).getPropertyValue('--button_text-color').trim();
    const closeButtonTextColor = getComputedStyle(root).getPropertyValue('--close-button_text-color').trim();
    const defaultIcons = {
        'Add': <IoIosAddCircleOutline />,
        'Assign' : <MdOutlineAssignmentTurnedIn />,
        'Import': <LuImport />,
        'Export': <PiExportBold />,
        'Filter': <FiFilter />,
      };
    let btnCls = {
        backgroundColor: 
        props.color === 'info' ? buttonBackgroundColor : closeButtonBackgroundColor,
        color: props.color === 'info' ? buttonTextColor : closeButtonTextColor,
    }; 

    // let btnCls = 'btn btn-outline-primary btn-rounded waves-effect';
    // btnCls = (props.color == 'danger') ? 'btn btn-outline-danger btn-rounded waves-effect' : 'btn btn-outline-primary btn-rounded waves-effect';
    return (
        <button
            type="button"
            className = 'btnCls'
            style={{
                ...btnCls,
                display: 'flex',          
                alignItems: 'center',     
                justifyContent: 'center',
                padding: '6px'
            }}         
            disabled={props.disabled}
            onClick={props.submit}>
            {props.type ? <span style={{ marginRight: '8px', scale:'1.4' }}>{defaultIcons[`${props.type}`]}</span> : ''}
           <p style={{ margin: 0 }}>{props.BName}</p>
           </button>
    );
}

export default ButtonField;